import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

// MD Dashboard v1 — every tile carries a STATE (live / no_data / stale / setup) and a TONE.
// Zero on a live tile = green + silent. Non-zero actionable = amber/red + clickable → the list.
// no_data / stale / setup render grey with an explicit badge and reason — never a fake 0.
const TONE = {
  green: { bg: '#F1FAF4', bd: '#CFE9D8', fg: '#0F7B3F' },
  amber: { bg: '#FDF7EA', bd: '#EADFC5', fg: '#8A5A0B' },
  red:   { bg: '#FCEBEB', bd: '#F2C7C7', fg: '#B42318' },
  grey:  { bg: '#F5F5F7', bd: '#E5E5EA', fg: '#7A7A80' },
};
const STATE_BADGE = { no_data: 'no data', stale: 'stale', setup: 'setup' };

export default function MDDashboard() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    api.get('/md-dashboard/summary').then((r) => setD(r.data.data)).catch((e) => setErr(e.response?.data?.error || 'Failed to load'));
  }, []);
  if (err) return <div style={{ padding: 30, color: '#A32D2D' }}>{err}</div>;
  if (!d) return <div style={{ padding: 30, color: '#aaa' }}>Loading…</div>;

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ margin: '0 0 2px', color: '#2D2C72', fontSize: 22 }}>MD Dashboard</h2>
      <div style={{ color: '#888', fontSize: 12, marginBottom: 18 }}>Whole business · as of {d.as_of}</div>
      {d.sections.map((sec) => (
        <div key={sec.label} style={{ marginBottom: 22 }}>
          <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1, color: '#8A8A8E', textTransform: 'uppercase', marginBottom: 8 }}>{sec.label}</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(230px,1fr))', gap: 12 }}>
            {sec.tiles.map((t) => {
              const c = TONE[t.tone] || TONE.grey;
              const clickable = !!t.link;
              return (
                <div key={t.key}
                  onClick={() => clickable && nav(t.link)}
                  title={clickable ? 'Open the list' : ''}
                  style={{ background: c.bg, border: `1px solid ${c.bd}`, borderRadius: 10, padding: '13px 15px', cursor: clickable ? 'pointer' : 'default', transition: 'box-shadow .12s', minHeight: 92, boxSizing: 'border-box' }}
                  onMouseEnter={(e) => { if (clickable) e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 6 }}>
                    <div style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>{t.key}{clickable && <span style={{ color: c.fg, opacity: 0.55, marginLeft: 4 }}>↗</span>}</div>
                    {STATE_BADGE[t.state] && <span style={{ fontSize: 9, fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.4, color: c.fg, background: '#fff', border: `1px solid ${c.bd}`, borderRadius: 6, padding: '1px 6px', whiteSpace: 'nowrap' }}>{STATE_BADGE[t.state]}</span>}
                  </div>
                  <div style={{ fontSize: t.state === 'live' ? 25 : 17, fontWeight: 800, color: c.fg, marginTop: 6 }}>{t.value}</div>
                  {t.detail && <div style={{ fontSize: 11, color: '#8A8A8E', marginTop: 4, lineHeight: 1.35 }}>{t.detail}</div>}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
